export const ActionTypes = {
  LOADING: "MASTERPLAN_LIST_LOADING",
  ERROR: "MASTERPLAN_LIST_ERROR",
  SUCCESS: "MASTERPLAN_LIST_SUCCESS",
};
